export default "__VITE_ASSET__DiwC7wQH__"